import TaskCard from '@/components/TaskView/TaskCard.tsx';

import { useBookingTaskContext } from '@/hooks/use-booking-task-context.ts';

import { TaskModalMode } from '@/models/TaskModalMode.ts';
import { DCTaskStatus, EnrichedTask } from '@/models/doc-cirrus/DCTask.ts';

import { useBookingStore } from '@/stores/bookingStore.ts';

import { openBookingTaskModal } from '@/utils/task-utils.tsx';

export const BookingTaskTiles = () => {
    const bookingTasks = useBookingStore((state) => state.booking_tasks);
    const addBookingTask = useBookingStore((state) => state.addBookingTask);
    const removeBookingTask = useBookingStore((state) => state.removeBookingTask);
    const { tasksEnabled } = useBookingTaskContext();

    const visibleTasks = bookingTasks.filter((task) => task.status !== DCTaskStatus.DONE);

    if (!tasksEnabled || visibleTasks.length === 0) return undefined;

    const handleTileClick = (task: EnrichedTask): void =>
        openBookingTaskModal({
            mode: TaskModalMode.DETAILS,
            task: task,
            onSaved: addBookingTask,
            onDeleted: removeBookingTask,
        });

    return (
        <div className="flex flex-col gap-3">
            {visibleTasks.map((task) => (
                <TaskCard
                    key={`${task.instance_id}-${task.id}`}
                    task={task}
                    onClick={handleTileClick}
                    showLocationAndAssignee
                    compact
                />
            ))}
        </div>
    );
};
